import { render, staticRenderFns } from "./Categoires.vue?vue&type=template&id=281b8c64&scoped=true"
import script from "./Categoires.vue?vue&type=script&lang=js"
export * from "./Categoires.vue?vue&type=script&lang=js"
import style0 from "./Categoires.vue?vue&type=style&index=0&id=281b8c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b8c64",
  null
  
)

export default component.exports